import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import PropertiesActions from 'app/shared/actions/PropertiesActions';

import PropertyPanelModel from 'app/shared/model/PropertyPanel';

// utils
import { escapeRoute } from 'app/shared/utils/escapeRoute';

import InteractiveCard from 'app/shared/components/InteractiveCard';
import LayoutWithSubTitle from './components/LayoutWithSubTitle';
import LayoutWithoutSubTitle from './components/LayoutWithoutSubTitle';

import {
    StyledLink,
} from './StyledComponents';

const PropertyPanel = ({
    isConnectedExperience,
    listingAlias: propertyId,
    panelModel,
}) => {
    const dispatch = useDispatch();

    const {
        id,
        isDisabled,
        urlPath,
    } = panelModel;

    const handleLinkClick = (event) => {
        event.preventDefault();

        // update on route change: fixes incorrect connected access
        // FIND: update listing isConnectedExperience
        dispatch(PropertiesActions.getIsConnectedExperience(propertyId)).finally(() => {
            // some routes need to be escaped as they are served on a different server
            if (escapeRoute(id)) {
                window.router.updateLocation(urlPath);
            } else {
                window.router.transitionTo(urlPath);
            }
        });
    };

    return (
        <div className="PropertyPanel">
            {isDisabled ? (
                <InteractiveCard isDisabled={isDisabled}>
                    {isConnectedExperience
                        ? <LayoutWithSubTitle panelModel={panelModel} />
                        : <LayoutWithoutSubTitle panelModel={panelModel} />
                    }
                </InteractiveCard>
            ) : (
                <StyledLink
                    to={urlPath}
                    disabled={isDisabled}
                    onClick={handleLinkClick}
                >
                    <InteractiveCard isDisabled={isDisabled}>
                        {isConnectedExperience
                            ? <LayoutWithSubTitle panelModel={panelModel} />
                            : <LayoutWithoutSubTitle panelModel={panelModel} />
                        }
                    </InteractiveCard>
                </StyledLink>
            )}
        </div>
    );
};

PropertyPanel.propTypes = {
    isConnectedExperience: PropTypes.bool.isRequired,
    listingAlias: PropTypes.string.isRequired,
    panelModel: PropTypes.shape({
        isDisabled: PropTypes.bool.isRequired,
        message: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        title: PropTypes.string.isRequired,
        urlPath: PropTypes.string.isRequired,
    }),
};

PropertyPanel.defaultProps = {
    panelModel: PropertyPanelModel({}),
};

export default PropertyPanel;
